<template>
  <LoadOnVisible  v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header>
        <!-- title and subtitle -->
        <div>
          <b-card-title class="mb-1" title-tag="h5">
            Missing Inventory - Warehouse Items
          </b-card-title>
        </div>

        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >with Warning or Urgent Status
        </span>
        <!-- datepicker -->
      </b-card-header>

      <b-card-body class="p-0">
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <TableListing
          v-if="items"
            class="mt-0"
            moreCustom5Class="nopadinr"
            sticky-header
            :responsive="true"
            :fixed="false"
            head-variant="light"
            :hide-pagination-top-fields="true"
            :loading-page="isLoadingChartData"
            :items.sync="items"
            :showPaginationRow="false"
            :fields.sync="tableColumns"
            :bordered="false"
          >
          <template v-slot:cell(projectId)="data">
              <span
                v-if="myProjects && myProjects.find(a => a.id == data.item.projectId)"
                >{{ myProjects.find(a => a.id == data.item.projectId).name }}</span
              >
              <span v-else>-</span>
            </template>
            <template v-slot:cell(inventoryStatus)="data"
              ><span
                v-if="data.item.inTransit > 0"
                class="badge badge-primary mr-1"
                v-b-tooltip.hover
                :title="'In Transit: ' + data.item.inTransit"
              >
                <i class="fa fa-exchange"></i>
              </span>
              <router-link
                :to="{
                  name: 'Warehouses.Items',
                  query: { sku: data.item.sku, warehouseId: data.item.warehouseId, brandId: data.item.brandId }
                }"
              >
              <InventoryStatusBadge :inventoryStatus="data.item.inventoryStatus"></InventoryStatusBadge>
              </router-link>
            </template>
            <template v-slot:cell(sku)="data">
              <span
                v-b-tooltip.hover
                :title="
                  'Name: ' +
                    data.item.name
                "
              >{{ data.item.sku }}</span>
            </template>
          </TableListing>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import InventoryStatusBadge from '@/views/components/InventoryStatusBadge.vue';
import { TableListing, LoadOnVisible } from '@/views/components/custom';

export default {
  mixins: [myCommonDataMixin],
  components: {
    InventoryStatusBadge,
    TableListing,
    LoadOnVisible
  },
  data() {
    return {
      tableOpts: {
        totalRows: 0,
        loadedAll: true
      },
      items: [],
      tableColumns: [
        { key: 'warehouseName', label: 'Warehouse', sortable: false },
        { key: 'sku', label: 'Item Code', sortable: false },
        //{ key: 'name', label: 'Name', sortable: false },
        //{ key: 'isMapped', label: 'Is Mapped', sortable: false },
        //{ key: 'createDate', label: 'Date Added', sortable: false },
        //{ key: 'lastSoldDate', label: 'Last Sold', sortable: false },

        //{ key: 'quantity', label: 'OnHand', sortable: false },
        //{ key: 'quantityDemand', label: 'Demand', sortable: false },
        { key: 'quantityAvail', label: 'Available', sortable: false },
        //{ key: 'inTransit', label: 'In-Transit', sortable: false },
        //{ key: 'soldPerWeekAvg', label: 'Avg Wkly Demand', sortable: false },
        //{ key: 'wksAvail', label: 'Wks Avail', sortable: false },

        { key: 'inventoryStatus', label: 'Status', sortable: false }
        //{ key: 'productId', label: 'Action', sortable: false }
      ],
      isLoadingChartData: true
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  methods: {
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/analytics/missing-inventory-warehouse', {})
        .then(resp => {
          this.isLoadingChartData = false;
          let xAxisLabels = [];
          let dataPoints = [];
          this.items = resp.data.items;
          this.tableOpts.totalRows = this.items.length;
          // items.forEach(itm => {
          //   dataPoints.push({ x: itm.sku, y: itm.quantity });
          //   xAxisLabels.push(itm.sku);
          // });
          // this.chartData.series[0].data = dataPoints;
          // this.chartData.chartOptions.xaxis.categories = xAxisLabels;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.items = [];
        });
    }
  },
  mounted() {
  }
};
</script>
